<template>
  <div class="client-container">
    <a-form :form="pageSearchForm">
      <a-form-item>
        <a-select
          v-decorator="[
            'platform_type',
            {
              initialValue: searchArgs.platform_type
            }
          ]"
          class="activity-config-search"
          :style="{
            width: '120px',
            marginRight: '20px'
          }"
          :loading="loadingSearchCompany"
          placeholder="请选择平台"
          @change="handleChangePlatform"
        >
          <a-select-option key="cp" value="cp">
            药企端
          </a-select-option>
          <a-select-option key="sp" value="sp">
            服务商端
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item>
        <a-select
          v-decorator="[
            'company_id',
            {
              initialValue: searchArgs.company_id
            }
          ]"
          class="activity-config-search"
          :style="{
            width: '300px'
          }"
          :loading="loadingSearchCompany"
          placeholder="请选择企业"
          @change="handleChangeCompany"
        >
          <a-select-option
            v-for="item in searchArgs.company_list"
            :key="item.id"
            :title="item.companyInfo.qichacha_name"
          >
            {{ item.companyInfo.qichacha_name }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <a-table
      :pagination="showPagination"
      :columns="tableColumns"
      :data-source="tableDataList"
      :row-selection="rowSelection"
      :scroll="{ x: 800, y: 450 }"
    />

    <a-button
      type="dashed"
      :style="{
        width: '200px',
        height: '40px',
        margin: '15px 10px 0px'
      }"
      @click.stop="closeWin"
    >
      取 消
    </a-button>
    <a-button
      type="primary"
      :style="{
        width: '200px',
        height: '40px',
        margin: '15px 10px 0px'
      }"
      @click.stop="bindArea"
    >
      绑 定
    </a-button>
  </div>
</template>
<script>
var pageContext;
export default {
  props: {
    itemData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    layerid: {
      type: String,
      default: ""
    },
    lydata: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showPagination: false,
      pageSearchForm: this.$form.createForm(this),
      loadingSearchCompany: false,
      // 检索参数
      company_label: "药企",
      searchArgs: {
        platform_type: "cp", // 选择平台
        company_id: "1",
        company_list: [] // 当前选择企业列表
      },
      tableColumns: [
        {
          title: "名称",
          dataIndex: "name",
          key: "name"
        },
        {
          title: "编号",
          dataIndex: "id",
          key: "id",
          width: "180px"
        },
        {
          title: "排序",
          dataIndex: "sort",
          key: "sort",
          width: "100px"
        }
      ],
      tableDataList: [],
      selectRowKeyList: [],
      rowSelection: {
        type: "radio",
        fixed: true,
        onChange: (selectedRowKeys, selectedRows) => {
          pageContext.selectRowKeyList = selectedRowKeys;
        },
        getCheckboxProps: record => {
          return {
            props: {
              defaultChecked: pageContext.selectRowKeyList.includes(record.id)
            }
          };
        }
      }
    };
  },
  async mounted() {
    pageContext = this;
    pageContext.handleChangePlatform("cp");
  },
  methods: {
    async handleChangePlatform(value) {
      pageContext.searchArgs.platform_type = value;
      pageContext.company_label = value === "cp" ? "药企" : "服务商";

      pageContext.searchArgs.company_list = [];
      pageContext.searchArgs.company_id = "";
      pageContext.pageSearchForm.setFieldsValue({
        company_id: pageContext.searchArgs.company_id
      });
      pageContext.tableDataList = [];
      pageContext.loadingSearchCompany = true;
      pageContext.$http
        .post("/Promoter/getBindCompany", {
          id: pageContext.itemData.id,
          platform_type: pageContext.searchArgs.platform_type
        })
        .then(function(response) {
          if (
            response.data.status === 1 &&
            response.data.data.data_list.length > 0
          ) {
            pageContext.$message.success(
              "请选择：" + pageContext.company_label
            );
            pageContext.searchArgs.company_list = response.data.data.data_list;
            pageContext.searchArgs.company_id =
              pageContext.searchArgs.company_list[0].id;
            pageContext.pageSearchForm.setFieldsValue({
              company_id: pageContext.searchArgs.company_id
            });
            pageContext.handleChangeCompany(pageContext.searchArgs.company_id);
          }

          pageContext.loadingSearchCompany = false;
        })
        .catch(function(error) {
          pageContext.loadingSearchCompany = false;
          console.log(error);
        });
    },
    async handleChangeCompany(value) {
      pageContext.searchArgs.company_id = value;
      pageContext.tableDataList = [];
      pageContext.searchArgs.company_list.forEach(item => {
        if (value === item.id) {
          pageContext.selectRowKeyList = item.area_bind;
        }
      });
      pageContext.refreshDataList();
    },
    async refreshDataList() {
      pageContext.$http
        .post("/area/getDataList", {
          platform_type: pageContext.searchArgs.platform_type,
          company_id: pageContext.searchArgs.company_id
        })
        .then(function(response) {
          if (
            response.data.status === 1 &&
            response.data.data.data_list.length > 0
          ) {
            pageContext.tableDataList = response.data.data.data_list;
          }
        })
        .catch(function(error) {
          pageContext.$message.error("请求异常，请检查");
          console.log(error);
        });
    },
    async bindArea() {
      pageContext.$http
        .post("/Promoter/bindArea", {
          id: pageContext.itemData.id,
          platform_type: pageContext.searchArgs.platform_type,
          company_id: pageContext.searchArgs.company_id,
          area_bind: pageContext.selectRowKeyList
        })
        .then(function(response) {
          if (response.data.status === 1) {
            pageContext.$parent.refreshDataList();
            pageContext.$message.success(response.data.msg);
            pageContext.$layer.close(pageContext.layerid);
          }
        })
        .catch(function(error) {
          pageContext.$message.error("请求异常，请检查");
          console.log(error);
        });
    },
    closeWin() {
      pageContext.$message.info("操作取消");
      pageContext.$layer.close(pageContext.layerid);
    }
  }
};
</script>
<style lang="scss" scoped>
.client-container {
  width: 100%;

  .ant-btn-circle {
    margin: 0px 5px;
  }

  .ant-form {
    display: flex;
  }
}
</style>
